import { render, staticRenderFns } from "./IconAmazon.vue?vue&type=template&id=f096ae92&"
import script from "./IconAmazon.vue?vue&type=script&lang=js&"
export * from "./IconAmazon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports